import { axiosInstance as axios } from 'helpers/axios/axiosInstance';
import logger from 'helpers/logger';
import { JOBLIST_API_URL } from 'application/adapters/cms/_constants';

export const getJobListFromRepository = (params: Models.JobList): Promise<Models.Job> => {
	const jobListApiUrl = JOBLIST_API_URL ?? process.env.NEXT_PUBLIC_JOBLIST_API_URL;
	const { departmentId, numberOfJobs } = params;
	const url = new URL(jobListApiUrl);
	url.searchParams.append('depid', departmentId.toString());
	const jobCount = numberOfJobs && numberOfJobs > 0 ? numberOfJobs : 100;
	url.searchParams.append('take', jobCount.toString());
	const fullUrl = url.toString();

	return axios(fullUrl)
		.then((res) => {
			return res?.data;
		})
		.catch((error) => {
			logger.error(`[${error?.response?.status}] JOBLIST_API_ERROR \nFailed retrieving joblist from API`, {
				error,
			});
			throw error;
		});
};
